export const parseSqlDateTimeNullable = (
    datetime: string | undefined | null
): Date | undefined => {
    if (!datetime) return undefined;
    const formattedDatetime = datetime
        .substring(0, 19)
        .replace("T", " ")
        .replace(/-/g, "/");
    return new Date(formattedDatetime);
};
export const parseSqlDateTime = (datetime: string): Date => {
    const formattedDatetime = datetime
        .substring(0, 19)
        .replace("T", " ")
        .replace(/-/g, "/");
    console.log(datetime + ": " + formattedDatetime);
    return new Date(formattedDatetime);
};

export const formatDateString = (date: Date): string =>
    `${date.getFullYear()}-${
        date.getMonth() + 1 < 0
            ? `0${date.getMonth() + 1}`
            : date.getMonth() + 1
    }-${date.getDate() < 0 ? `0${date.getDate()}` : date.getDate()}`;

export const formatTimeString = (date: Date) =>
    `
    ${date.getHours() < 10 ? "0" : ""}${date.getHours()}:${
        date.getMinutes() < 10 ? "0" : ""
    }${date.getMinutes()}:${
        date.getSeconds() < 10 ? "0" : ""
    }${date.getSeconds()}
`;

export const capitalizeFirstLetter = (
    word: string,
    locale = navigator.language
): string => {
    const [first, ...rest] = word.split("");
    return first.toLocaleUpperCase(locale) + rest.join("");
};

interface RgbObject {
    r: number;
    g: number;
    b: number;
}

export const hexToRgb = (
    hex: string,
    type: "string" | "object"
): string | RgbObject | null => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    if (type === "string") {
        return result
            ? result
                  .slice(1, undefined)
                  .map((color) => parseInt(color, 16))
                  .join(", ")
            : null;
    } else if (type === "object") {
        return result
            ? {
                  r: parseInt(result[1], 16),
                  g: parseInt(result[2], 16),
                  b: parseInt(result[3], 16),
              }
            : null;
    }
    return null;
};

export const validatePassword = (password: string): boolean => {
    const invalidChars = ['"', "'", ";", "#"];
    return (
        /[A-Z]/.test(password) &&
        /[a-z]/.test(password) &&
        /[0-9]/.test(password) &&
        /[^A-Za-z0-9]/.test(password) &&
        password.length >= 12 &&
        invalidChars.filter((character) => password.includes(character))
            .length === 0
    );
};

export const validateEmail = (email: string): boolean => {
    const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
};

export const isEmpty = (str: string | string[]): boolean => {
    if (typeof str === "string") {
        if (!str) return true;
        if (str.length === 0) return true;
        if (!/[^\s]/.test(str)) return true;
        return false;
    } else {
        return str.length === 0;
    }
};

export const validateIpv4Address = (
    address: string
): "success" | "error-address" | "error-range" => {
    if (!address.includes("/")) {
        return !address.startsWith("0.0.0.0") &&
            /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/.test(
                address
            )
            ? "success"
            : "error-address";
    } else {
        const range = address.split("/")[1];
        const ip = address.split("/")[0];
        const power = 32 - parseInt(range);
        const ipArray = ip.split(".");

        if (power < 0 || power > 32) {
            return "error-range";
        }

        if (ipArray.length !== 4) {
            return "error-address";
        }

        for (let i = 0; i < 4; i++) {
            if (parseInt(ipArray[i]) < 0 || parseInt(ipArray[i]) > 255) {
                return "error-address";
            }
        }

        const ipConvertedFromBinary = ipArray
            .map((byte) => parseInt(byte).toString(2).padStart(8, "0"))
            .join("");

        return ipConvertedFromBinary.slice(
            ipConvertedFromBinary.length - power
        ) === "0".repeat(power)
            ? "success"
            : "error-range";
    }
};

export const validateIpv6Address = (
    address: string
): "success" | "error-address" => {
    const rgx =
        /(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))(\/(12[0-8]|1[0-1][0-9]|[1-9][0-9]|[0-9]))?$/;
    return rgx.test(address) ? "success" : "error-address";
};

export const checkPermission = (
    permissions: string[],
    routes: string[]
): boolean => {
    let hasPermission = false;
    routes.forEach((route) => {
        if (permissions.includes(route)) {
            hasPermission = true;
        }
    });
    return hasPermission;
};

export const allyProps = (index: number) => {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
};

export const getColorFromName = (name: string) => {
    const colors = [
        "#6667AB",
        "#31BCDB",
        "#65DEA4",
        "#FF7179",
        "#FFB967",
        "#E68EF4",
        "#FB805A",
        "#7F8AE8",
    ];

    const sum = Array.from(name).reduce(
        (prev, curr) => prev + curr.charCodeAt(0),
        0
    );

    const index = sum % colors.length;

    return colors[index];
};

export const getSelected = (
    route: string | string[],
    exact: boolean = false,
    pathname: string
) => {
    if (typeof route === "string") {
        if (exact) {
            return route === pathname;
        } else {
            return route.split("/")[1] === pathname.split("/")[1];
        }
    } else {
        return (
            route.filter((r) => r.split("/")[1] === pathname.split("/")[1])
                .length > 0
        );
    }
};
